import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createABAMiddleware } from '@corefront/redux-aba';
import { reduxSearch } from 'redux-search';
import service from '../services';
import rootReducer from './reducers';
import rootSaga from './sagas';
import { GAMES_RESOURCE_NAME, GAMES_SEARCH_FIELD } from './constants/search';
import {
  resourceStateSelector,
  searchStateSelector,
} from './reducers/app/search';
import { composeEnhancers } from './store.dev';

const abaMiddleware = createABAMiddleware(service);
const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, abaMiddleware];

/**
 * Settings for redux-search enhancer
 * More information about configuration https://github.com/bvaughn/redux-search
 */
const reduxSearchEnhancer = () => {
  return reduxSearch({
    resourceIndexes: {
      [GAMES_RESOURCE_NAME]: [GAMES_SEARCH_FIELD],
    },
    resourceSelector: resourceStateSelector,
    searchStateSelector: searchStateSelector,
  });
};

export default function configureStore(initialState = {}) {
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares), reduxSearchEnhancer())
  );

  sagaMiddleware.run(rootSaga);

  return store;
}
